<template>
  <div class="expand-paragraph">
    <p>
      <span v-if="!isExpanded">
        <div class="" v-html="shortText"> </div>
      </span>
      <span v-else>
        {{ text }}
      </span>

      <span v-if="isTruncated">
        <a href="javascript:void(0)" @click="toggle" class="toggle-btn">
          {{ isExpanded ? collapseLabel : expandLabel }}
        </a>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "ExpandParagraph",
  props: {
    text: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 150,
    },
    expandLabel: {
      type: String,
      default: "Lihat selengkapnya",
    },
    collapseLabel: {
      type: String,
      default: "Lebih sedikit",
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    isTruncated() {
      return this.text.length > this.limit;
    },
    shortText() {
      if (!this.isTruncated) return this.text;
      return this.text.substring(0, this.limit) + "... ";
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style scoped>
.toggle-btn {
  color: #3490dc;
  cursor: pointer;
  font-weight: 500;
  margin-left: 6px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/workflow/components/ExpandParagraph.vue